(function() {
  'use strict';
// Model-specific assets and overrides. Shared assets (seat-mask, rim-mask,
// starlight-mask, roof-led, seat-black) work across all models because the
// camera angle and sizing are aligned in every master render.
const MODELS = {
  ge: {
    handle: "ge-series",
    title: "2026 GE Series",
    master: "master-ge.jpg",
    bodyMask: "body-mask-ge.png",
    basePrice: 9895,
    overrides: {
      bodyColor: {
        "Black":          "body-black-ge.png",
        "Silver":         "body-silver-ge.png",
        "Nardo Grey":     "body-nardogrey-ge.png",
        "Dark Grey":      "body-darkgrey-ge.png",
        "Royal Blue":     "body-royalblue-ge.png",
        "Baby Blue":      "body-babyblue-ge.png",
        "Vein Red":       "body-veinred-ge.png",
        "Citrus Orange":  "body-orange-ge.png",
        "Emerald Green":  "body-emeraldgreen-ge.png",
        "Purple":         "body-purple-ge.png",
        "Coffee Brown":   "body-coffeebrown-ge.png"
      }
    }
  },
  gh: {
    handle: "gh-series",
    title: "2026 GH Series",
    master: "master-gh.png",
    bodyMask: "body-mask-gh.png",
    basePrice: 9560,
    overrides: {
      bodyColor: {
        "Black":          "body-black-gh.png",
        "Silver":         "body-silver-gh.png",
        "Nardo Grey":     "body-nardogrey-gh.png",
        "Dark Grey":      "body-darkgrey-gh.png",
        "Royal Blue":     "body-royalblue-gh.png",
        "Baby Blue":      "body-babyblue-gh.png",
        "Vein Red":       "body-veinred-gh.png",
        "Citrus Orange":  "body-orange-gh.png",
        "Emerald Green":  "body-emeraldgreen-gh.png",
        "Purple":         "body-purple-gh.png",
        "Coffee Brown":   "body-coffeebrown-gh.png"
      }
    }
  },
  gi: {
    handle: "gi-series",
    title: "2026 GI Series",
    master: "master-gi.jpg",
    bodyMask: "body-mask-gi.png",
    basePrice: 8995,
    overrides: {
      bodyColor: {
        "Black":          "body-black-gi.png",
        "Silver":         "body-silver-gi.png",
        "Nardo Grey":     "body-nardogrey-gi.png",
        "Dark Grey":      "body-darkgrey-gi.png",
        "Royal Blue":     "body-royalblue-gi.png",
        "Baby Blue":      "body-babyblue-gi.png",
        "Vein Red":       "body-veinred-gi.png",
        "Citrus Orange":  "body-orange-gi.png",
        "Emerald Green":  "body-emeraldgreen-gi.png",
        "Purple":         "body-purple-gi.png",
        "Coffee Brown":   "body-coffeebrown-gi.png"
      }
    }
  }
};

const CATALOG = {
  basePrice: 9760,
  groups: [
    {
      id: "seatCapacity",
      label: "Seat Capacity",
      type: "single",
      mandatory: true,
      affectsRender: false,
      displayAs: "dropdown",
      choices: [
        { id: "2",   price: 0 },
        { id: "2+2", price: 670 },
        { id: "4",   price: 580 },
        { id: "4+2", price: 1250 },
        { id: "6",   price: 1110 },
        { id: "6+2", price: 1790 }
      ]
    },
    {
      id: "bodyColor",
      label: "Body Color",
      type: "single",
      mandatory: true,
      affectsRender: true,
      choices: [
        { id: "Black",          hex: "#000000", price: 0 },
        { id: "White",          hex: "#f5f5f5", price: 0 },
        { id: "Silver",         hex: "#c0c0c0", price: 0 },
        { id: "Nardo Grey",     hex: "#9c9c9c", price: 0 },
        { id: "Dark Grey",      hex: "#4a4a4a", price: 0 },
        { id: "Royal Blue",     hex: "#1a2b6e", price: 0 },
        { id: "Baby Blue",      hex: "#7db6e0", price: 0 },
        { id: "Vein Red",       hex: "#6e1414", price: 0, overrideAsset: "body-veinred.png" },
        { id: "Peel Yellow",    hex: "#ffd633", price: 0 },
        { id: "Citrus Orange",  hex: "#f08030", price: 0 },
        { id: "Emerald Green",  hex: "#1f6b3f", price: 0 },
        { id: "Purple",         hex: "#3f1860", price: 0 },
        { id: "Coffee Brown",   hex: "#3a2a20", price: 0 }
      ]
    },
    {
      id: "twoToneHood",
      label: "Two-Tone Hood (Black)",
      type: "boolean",
      mandatory: false,
      affectsRender: true,
      price: 0,
      models: ["gh"]
    },
    {
      id: "paintFinish",
      label: "Paint Finish",
      type: "single",
      mandatory: true,
      affectsRender: false,
      choices: [
        { id: "Gloss", price: 0 },
        { id: "Matte", price: 1200 }
      ]
    },
    {
      id: "primarySeatColor",
      label: "Primary Seat Color",
      type: "single",
      mandatory: true,
      affectsRender: true,
      choices: [
        { id: "Black",      hex: "#000000", price: 0,   overrideAsset: "seat-black.png" },
        { id: "White",      hex: "#f5f5f5", price: 700, overrideAsset: "seat-white.png" },
        { id: "Baby Blue",  hex: "#7db6e0", price: 700, overrideAsset: "seat-babyblue.png" },
        { id: "Royal Blue", hex: "#1a2b6e", price: 700, overrideAsset: "seat-royalblue.png" },
        { id: "Brown",      hex: "#3a2a20", price: 700, overrideAsset: "seat-brown.png" },
        { id: "Beige",      hex: "#d8c8a0", price: 700, overrideAsset: "seat-beige.png" },
        { id: "Orange",     hex: "#f08030", price: 700, overrideAsset: "seat-orange.png" },
        { id: "Yellow",     hex: "#ffd633", price: 700, overrideAsset: "seat-yellow.png" },
        { id: "Red",        hex: "#6e1414", price: 700, overrideAsset: "seat-red.png" }
      ]
    },
    {
      id: "twoToneSeat",
      label: "Two-Tone Seat Finish",
      type: "boolean",
      mandatory: false,
      affectsRender: true,
      price: 390,
      overrideAsset: "seat-twotone-mask.png",
      disabledWhen: { primarySeatColor: "Black" }
    },
    {
      id: "stitchingColor",
      label: "Seat Stitching Color",
      type: "single",
      mandatory: true,
      affectsRender: false,
      choices: [
        { id: "Black", price: 0 },
        { id: "White", price: 0 }
      ]
    },
    {
      id: "tire",
      label: "Tire",
      type: "single",
      mandatory: true,
      affectsRender: true,
      choices: [
        { id: "Road",        price: 0,   overrideAsset: "tire-road.png" },
        { id: "All-Terrain", price: 120 }
      ]
    },
    {
      id: "tireSize",
      label: "Tire Size",
      type: "single",
      mandatory: true,
      affectsRender: false,
      choices: [
        { id: '12"', price: 0 },
        { id: '14"', price: 140 },
        { id: '15"', price: 190 }
      ]
    },
    {
      id: "rimStyle",
      label: "Rim Style",
      type: "single",
      mandatory: true,
      affectsRender: true,
      displayAs: "thumbnails",
      choices: [
        { id: "Black/Silver", price: 0,   overrideAsset: "rim-black-silver.png", thumb: "rim-black-silver.png" },
        { id: "Black/Black",  price: 140, overrideAsset: "rim-black-black.png",  thumb: "rim-black-black.png" },
        { id: "Red/Silver",   price: 140, overrideAsset: "rim-red-silver.png",   thumb: "rim-red-silver.png" },
        { id: "Black/Orange", price: 140, overrideAsset: "rim-black-orange.png", thumb: "rim-black-orange.png" },
        { id: "Black/Gold",   price: 140, overrideAsset: "rim-black-gold.png",   thumb: "rim-black-gold.png" }
      ]
    },
    {
      id: "starlightRoof",
      label: "Starlight Roof",
      type: "boolean",
      mandatory: false,
      affectsRender: true,
      price: 1150
    },
    {
      id: "motor",
      label: "Motor",
      type: "single",
      mandatory: true,
      affectsRender: false,
      choices: [
        { id: "48V 105AH", label: "48V 105AH · 40–50 mi range", price: 0 },
        { id: "48V 150AH", label: "48V 150AH · 60–65 mi range", price: 515 }
      ]
    },
    {
      id: "windshield",
      label: "Windshield",
      type: "single",
      mandatory: true,
      affectsRender: false,
      choices: [
        { id: "Folding",        price: 0 },
        { id: "Standard+Wiper", price: 250 }
      ]
    },
    {
      id: "frontRail",
      label: "Front Rail",
      type: "boolean",
      mandatory: false,
      affectsRender: false,
      price: 90
    },
    {
      id: "frontBucket",
      label: "Front Bucket",
      type: "boolean",
      mandatory: false,
      affectsRender: true,
      price: 65,
      overrideAsset: "front-bucket.png"
    },
    {
      id: "steeringAdjustable",
      label: "Adjustable Steering Wheel",
      type: "boolean",
      mandatory: false,
      affectsRender: false,
      price: 90
    },
    {
      id: "seatExtras",
      label: "Seat Extras",
      type: "multi",
      mandatory: false,
      affectsRender: false,
      choices: [
        { id: "adjustableLever", label: "Adjustable Lever", price: 95 },
        // Armrest price scales with seat count (one set per row).
        { id: "armrests", label: "Armrests", price: 55, priceBy: "seatCapacity",
          priceMap: { "2": 55, "2+2": 110, "4": 110, "4+2": 165, "6": 165, "6+2": 220 } },
        // Seat heating scales with total seat count.
        { id: "seatHeating", label: "Seat Heating", price: 410, priceBy: "seatCapacity",
          priceMap: { "2": 410, "2+2": 510, "4": 510, "4+2": 610, "6": 610, "6+2": 710 } }
      ]
    },
    {
      id: "dashboardExtras",
      label: "Dashboard Extras",
      type: "multi",
      mandatory: false,
      affectsRender: false,
      choices: [
        { id: "usbPort",     label: "Extra USB Port",  price: 25 },
        { id: "startButton", label: "Push Start/Key Fob", price: 150 }
      ]
    },
    {
      id: "golfEquipment",
      label: "Golf Equipment Accessories",
      type: "multi",
      mandatory: false,
      affectsRender: false,
      choices: [
        { id: "bagHolder",      label: "Bag Holder",        price: 90 },
        { id: "bagCover",       label: "Bag Cover",         price: 275 },
        { id: "sandBottle",     label: "Sand Bottle",       price: 45 },
        { id: "ballClubCleaner",label: "Ball/Club Cleaner", price: 60 },
        { id: "scorecardHolder",label: "Scorecard Holder",  price: 30 },
        { id: "sandBucket",     label: "Sand Bucket",       price: 45 },
        { id: "iceBucket",      label: "Ice Bucket",        price: 60 }
      ]
    }
  ]
};

// --- Shared build codes ---------------------------------------------------
// A shared build used to travel as base64-encoded JSON of the whole state,
// which ran ~870 characters. Long query values don't survive the trip: an
// iMessage share arrived as ".../ge-series?build" with the value gone, so the
// link opened on defaults. The wire format is now a fixed 16-character code —
// one base36 digit per single-choice group, then every boolean and
// multi-select checkbox packed into a bitfield, five bits per digit.
//
// The code is positional, so it is tied to the order of CATALOG.groups and of
// the choices inside them. Keep both append-only. If either ever has to be
// reordered, bump CODE_VERSION so old links decode as null (falling back to
// defaults) instead of silently resolving to the wrong build.
const CODE_VERSION = "1";
const BITS_PER_DIGIT = 5; // 2^5 = 32 <= 36, so one base36 digit per chunk

// Single-choice groups, in catalog order — one digit each.
function singleGroups() {
  return CATALOG.groups.filter(g => g.type === "single");
}

// Every on/off selection, in catalog order. Booleans contribute one slot;
// multi groups contribute one slot per choice.
function flagSlots() {
  const slots = [];
  for (const group of CATALOG.groups) {
    if (group.type === "boolean") {
      slots.push({ groupId: group.id, choiceId: null });
    } else if (group.type === "multi") {
      for (const choice of group.choices) {
        slots.push({ groupId: group.id, choiceId: choice.id });
      }
    }
  }
  return slots;
}

function flagDigitCount() {
  return Math.ceil(flagSlots().length / BITS_PER_DIGIT);
}

function buildCodeLength() {
  return 2 + singleGroups().length + flagDigitCount();
}

function encodeBuildCode(state) {
  const modelKeys = Object.keys(MODELS);
  const modelIndex = Math.max(0, modelKeys.indexOf(state.modelKey));

  let code = CODE_VERSION + modelIndex.toString(36);

  for (const group of singleGroups()) {
    // Groups stay well under 36 choices, so each index is a single digit.
    const index = group.choices.findIndex(c => c.id === state[group.id]);
    code += (index < 0 ? 0 : index).toString(36);
  }

  // Build the bit string first, then chunk it — chunking keeps the format
  // working past the 32-bit ceiling that bitwise operators would impose.
  let bits = "";
  for (const slot of flagSlots()) {
    const value = slot.choiceId === null
      ? state[slot.groupId]
      : (state[slot.groupId] || {})[slot.choiceId];
    bits += value ? "1" : "0";
  }
  while (bits.length % BITS_PER_DIGIT !== 0) bits += "0";
  for (let i = 0; i < bits.length; i += BITS_PER_DIGIT) {
    code += parseInt(bits.slice(i, i + BITS_PER_DIGIT), 2).toString(36);
  }

  return code;
}

// Returns a complete state object, or null if the code isn't one we can trust.
// Callers fall back to defaults on null rather than showing a partial build.
function decodeBuildCode(code) {
  if (typeof code !== "string") return null;
  if (code.length !== buildCodeLength()) return null;
  if (code[0] !== CODE_VERSION) return null;
  if (!/^[0-9a-z]+$/.test(code)) return null;

  const state = defaultState();
  const modelKeys = Object.keys(MODELS);
  const modelIndex = parseInt(code[1], 36);
  if (!modelKeys[modelIndex]) return null;
  state.modelKey = modelKeys[modelIndex];

  let cursor = 2;
  for (const group of singleGroups()) {
    const choice = group.choices[parseInt(code[cursor], 36)];
    if (!choice) return null;
    state[group.id] = choice.id;
    cursor++;
  }

  let bits = "";
  for (; cursor < code.length; cursor++) {
    const digit = parseInt(code[cursor], 36);
    // Encoding never emits a digit above 31; a larger one would need six bits
    // and shift every flag after it, so treat the code as corrupt instead.
    if (digit >= 1 << BITS_PER_DIGIT) return null;
    bits += digit.toString(2).padStart(BITS_PER_DIGIT, "0");
  }
  flagSlots().forEach((slot, i) => {
    const on = bits[i] === "1";
    if (slot.choiceId === null) state[slot.groupId] = on;
    else state[slot.groupId][slot.choiceId] = on;
  });

  return state;
}

// Resolve the price for a multi/single choice. Some choices have a priceMap
// keyed by another option's value (e.g. armrests scale with seatCapacity).
function priceFor(choice, state) {
  if (choice && choice.priceMap && choice.priceBy) {
    const key = state[choice.priceBy];
    if (key in choice.priceMap) return choice.priceMap[key];
  }
  return choice ? choice.price : 0;
}

// Enforce option dependencies. Called at the start of every refresh — keeps
// state internally consistent regardless of what triggered the change.
function normalizeState(state) {
  // Two-tone seat overlay can't apply on top of black seats — the contrast
  // panel is already black, so the overlay would be invisible. Force off.
  if (state.primarySeatColor === "Black") state.twoToneSeat = false;
}

function defaultState() {
  return {
    bodyColor: "White",
    paintFinish: "Gloss",
    primarySeatColor: "Black",
    stitchingColor: "Black",
    tire: "Road",
    tireSize: '12"',
    rimStyle: "Black/Silver",
    starlightRoof: false,
    twoToneHood: false,
    twoToneSeat: false,
    seatCapacity: "2",
    motor: "48V 105AH",
    windshield: "Folding",
    frontRail: false,
    frontBucket: false,
    steeringAdjustable: false,
    seatExtras: { adjustableLever: false, armrests: false, seatHeating: false },
    dashboardExtras: { usbPort: false, startButton: false },
    golfEquipment: { bagHolder: false, bagCover: false, sandBottle: false, ballClubCleaner: false, scorecardHolder: false, sandBucket: false, iceBucket: false }
  };
}

function calculatePrice(state) {
  // Per-model base price if state knows which model; fallback to CATALOG.
  const modelBase = state.modelKey && MODELS[state.modelKey] && MODELS[state.modelKey].basePrice;
  let total = modelBase || CATALOG.basePrice;
  for (const group of CATALOG.groups) {
    if (group.type === "single") {
      const chosenId = state[group.id];
      const choice = group.choices.find(c => c.id === chosenId);
      if (choice) total += choice.price;
    } else if (group.type === "boolean") {
      if (state[group.id]) total += group.price;
    } else if (group.type === "multi") {
      const subState = state[group.id] || {};
      for (const choice of group.choices) {
        if (subState[choice.id]) total += priceFor(choice, state);
      }
    }
  }
  return total;
}

function isComplete(state) {
  for (const group of CATALOG.groups) {
    if (!group.mandatory) continue;
    if (group.type === "single") {
      const chosenId = state[group.id];
      const valid = group.choices.some(c => c.id === chosenId);
      if (!valid) return false;
    }
    // boolean and multi groups are not mandatory in this catalog
  }
  return true;
}

function buildPayload(state) {
  const properties = {};
  for (const group of CATALOG.groups) {
    if (group.type === "single") {
      const chosenId = state[group.id];
      const choice = group.choices.find(c => c.id === chosenId);
      if (!choice) continue;
      // Skip "None"/"No" choices for optional groups
      if (!group.mandatory && (chosenId === "None" || chosenId === "No")) continue;
      const display = choice.label || chosenId;
      properties[group.label] = choice.price > 0
        ? `${display} (+$${choice.price})`
        : display;
    } else if (group.type === "boolean") {
      if (state[group.id]) {
        properties[group.label] = `Yes (+$${group.price})`;
      }
    } else if (group.type === "multi") {
      const subState = state[group.id] || {};
      const selected = group.choices.filter(c => subState[c.id]);
      if (selected.length > 0) {
        properties[group.label] = selected.map(c => `${c.label} (+$${priceFor(c, state)})`).join(", ");
      }
    }
  }
  return {
    productHandle: "ge-series",
    properties,
    totalPrice: calculatePrice(state)
  };
}

function choiceFor(groupId, choiceId) {
  const group = CATALOG.groups.find(g => g.id === groupId);
  if (!group) return null;
  return group.choices ? (group.choices.find(c => c.id === choiceId) || null) : null;
}

function hexFor(groupId, choiceId) {
  const c = choiceFor(groupId, choiceId);
  return c && c.hex ? c.hex : null;
}

function isGrayscale(hex) {
  if (!hex) return false;
  const r = parseInt(hex.slice(1, 3), 16);
  const g = parseInt(hex.slice(3, 5), 16);
  const b = parseInt(hex.slice(5, 7), 16);
  return Math.abs(r - g) < 10 && Math.abs(g - b) < 10 && Math.abs(r - b) < 10;
}

function lightness(hex) {
  if (!hex) return 1;
  const r = parseInt(hex.slice(1, 3), 16) / 255;
  const g = parseInt(hex.slice(3, 5), 16) / 255;
  const b = parseInt(hex.slice(5, 7), 16) / 255;
  return (Math.max(r, g, b) + Math.min(r, g, b)) / 2;
}

function darkenAmount(hex) {
  const L = lightness(hex);
  const cap = isGrayscale(hex) ? 0.93 : 0.85;
  return Math.max(0, Math.min(cap, (1 - L) * 0.95));
}

function assetUrl(filename) {
  const base = (typeof window !== "undefined" && window.__NX_ASSET_BASE__) || "assets/";
  const prefix = (typeof window !== "undefined" && window.__NX_ASSET_PREFIX__) || "";
  return `${base}${prefix}${filename}`;
}

// Apply model-specific assets (master image + body mask). Called once per
// page load — the model doesn't change after that.
function applyModel(modelKey) {
  const config = MODELS[modelKey];
  if (!config) return;
  const root = document.documentElement;

  const masterImg = document.querySelector(".nx-cfg-layer-master");
  if (masterImg) masterImg.src = assetUrl(config.master);

  // Body mask (used by .nx-cfg-layer-body and .nx-cfg-layer-body-darken).
  // Set via CSS variable so the same CSS rules work for all models.
  root.style.setProperty("--nx-body-mask-url", `url("${assetUrl(config.bodyMask)}")`);

  // Replace every "GE" placeholder in the stage HUD with the actual model letter.
  const letter = modelKey.toUpperCase();
  document.querySelectorAll("[data-model-letter]").forEach(el => {
    el.textContent = letter;
  });
}

function applyState(state, modelKey) {
  const root = document.documentElement;
  const bodyHex = hexFor("bodyColor", state.bodyColor);
  const seatHex = hexFor("primarySeatColor", state.primarySeatColor);
  if (bodyHex) {
    root.style.setProperty("--nx-body-color", bodyHex);
    root.style.setProperty("--nx-body-darken", darkenAmount(bodyHex));
  }
  if (seatHex) {
    root.style.setProperty("--nx-seat-color", seatHex);
    root.style.setProperty("--nx-seat-darken", darkenAmount(seatHex));
  }
  const app = document.querySelector(".nx-cfg-app");
  if (app) app.dataset.paintFinish = state.paintFinish || "Gloss";

  // Body override: per-model. Look up in MODELS[modelKey].overrides.bodyColor.
  const modelConfig = MODELS[modelKey] || {};
  const bodyOverrideAsset = modelConfig.overrides?.bodyColor?.[state.bodyColor] || null;
  const isGloss = (state.paintFinish || "Gloss") === "Gloss";
  applyOverrideExplicit(app, bodyOverrideAsset, ".nx-cfg-layer-body-override", "bodyOverride", isGloss);

  // Seat overrides — universal across models since seat sizing matches.
  applyOverride(app, choiceFor("primarySeatColor", state.primarySeatColor), ".nx-cfg-layer-seat-override", "seatOverride", true);

  // Two-Tone Hood — GH only. Pre-rendered black hood overlay.
  const hoodActive = modelKey === "gh" && state.twoToneHood === true;
  applyOverrideExplicit(app, hoodActive ? "hood-gh.png" : null, ".nx-cfg-layer-hood-override", "hoodOverride", true);

  // Tire override — Road tires replace the master's all-terrain tires.
  // All-Terrain has no override (master shows through).
  applyOverride(app, choiceFor("tire", state.tire), ".nx-cfg-layer-tire-override", "tireOverride", true);

  // Rim style — pre-colored PNG overlay per Venom Strike colorway. Replaces
  // the legacy tinted rim-mask layer; CSS hides .nx-cfg-layer-rim when active.
  applyOverride(app, choiceFor("rimStyle", state.rimStyle), ".nx-cfg-layer-rim-override", "rimOverride", true);

  // Two-tone seat finish — overlay PNG above the seat color, only when the
  // primary seat color isn't already black (handled by normalizeState).
  const twoToneSeatGroup = CATALOG.groups.find(g => g.id === "twoToneSeat");
  const twoToneSeatAsset = state.twoToneSeat && twoToneSeatGroup && twoToneSeatGroup.overrideAsset
    ? twoToneSeatGroup.overrideAsset : null;
  applyOverrideExplicit(app, twoToneSeatAsset, ".nx-cfg-layer-seat-twotone-override", "seatTwotoneOverride", true);

  // Front Bucket — universal additive overlay (boolean group with overrideAsset).
  const bucketGroup = CATALOG.groups.find(g => g.id === "frontBucket");
  const bucketAsset = state.frontBucket && bucketGroup && bucketGroup.overrideAsset ? bucketGroup.overrideAsset : null;
  applyOverrideExplicit(app, bucketAsset, ".nx-cfg-layer-frontbucket-override", "frontbucketOverride", true);

  const starlightLayer = document.querySelector(".nx-cfg-layer-starlight");
  if (starlightLayer) {
    starlightLayer.dataset.starlight = state.starlightRoof ? "on" : "off";
  }
}

function applyOverride(app, choice, layerSelector, dataKey, enabled) {
  const asset = choice && choice.overrideAsset ? choice.overrideAsset : null;
  applyOverrideExplicit(app, enabled ? asset : null, layerSelector, dataKey, enabled);
}

function applyOverrideExplicit(app, asset, layerSelector, dataKey, enabled) {
  if (!app) return;
  const layerImg = document.querySelector(layerSelector);
  const useOverride = enabled && asset;
  if (useOverride) {
    if (layerImg) layerImg.src = assetUrl(asset);
    app.dataset[dataKey] = "true";
  } else {
    app.dataset[dataKey] = "false";
  }
}

function buildOptionPanel(state, container, modelKey) {
  container.innerHTML = "";
  for (const group of CATALOG.groups) {
    // Skip option groups that aren't available for the current model.
    if (group.models && modelKey && !group.models.includes(modelKey)) continue;

    const section = document.createElement("section");
    section.className = "nx-cfg-group";
    section.dataset.groupId = group.id;

    const heading = document.createElement("h3");
    heading.className = "nx-cfg-group-label";
    heading.textContent = group.label;
    section.appendChild(heading);

    if (group.type === "single") {
      if (group.displayAs === "dropdown") {
        section.appendChild(renderDropdown(group, state));
      } else if (group.displayAs === "thumbnails") {
        section.appendChild(renderThumbnails(group, state));
      } else {
        section.appendChild(renderSingle(group, state));
      }
    } else if (group.type === "boolean") {
      section.appendChild(renderBoolean(group, state));
    } else if (group.type === "multi") {
      section.appendChild(renderMulti(group, state));
    }

    container.appendChild(section);
  }
}

function labelFor(choice) {
  return choice.label || choice.id;
}

function renderSingle(group, state) {
  const wrap = document.createElement("div");
  wrap.className = "nx-cfg-choices";
  // Use swatches for color groups (those with hex values), radios otherwise
  const isSwatch = group.choices.some(c => c.hex);
  for (const choice of group.choices) {
    const el = document.createElement("label");
    el.className = isSwatch ? "nx-cfg-swatch" : "nx-cfg-radio";
    el.dataset.choiceId = choice.id;
    if (state[group.id] === choice.id) el.classList.add("is-selected");

    const input = document.createElement("input");
    input.type = "radio";
    input.name = group.id;
    input.value = choice.id;
    if (state[group.id] === choice.id) input.checked = true;
    el.appendChild(input);

    if (isSwatch) {
      const dot = document.createElement("span");
      dot.className = "nx-cfg-swatch-dot";
      dot.style.backgroundColor = choice.hex;
      el.appendChild(dot);
    }

    const name = document.createElement("span");
    name.className = "nx-cfg-choice-label";
    name.textContent = labelFor(choice);
    el.appendChild(name);

    if (choice.price > 0) {
      const price = document.createElement("span");
      price.className = "nx-cfg-choice-price";
      price.textContent = `+$${choice.price}`;
      el.appendChild(price);
    }
    wrap.appendChild(el);
  }
  return wrap;
}

function renderThumbnails(group, state) {
  const wrap = document.createElement("div");
  wrap.className = "nx-cfg-thumbs";
  for (const choice of group.choices) {
    const el = document.createElement("label");
    el.className = "nx-cfg-thumb";
    el.dataset.choiceId = choice.id;
    if (state[group.id] === choice.id) el.classList.add("is-selected");

    const input = document.createElement("input");
    input.type = "radio";
    input.name = group.id;
    input.value = choice.id;
    if (state[group.id] === choice.id) input.checked = true;
    el.appendChild(input);

    if (choice.thumb) {
      // Use a background-image cropped via CSS — the source PNG has wheels in
      // small corner positions, so a plain <img> would render mostly empty.
      const tile = document.createElement("span");
      tile.className = "nx-cfg-thumb-image";
      tile.style.backgroundImage = `url("${assetUrl(choice.thumb)}")`;
      tile.setAttribute("aria-label", labelFor(choice));
      el.appendChild(tile);
    }

    const name = document.createElement("span");
    name.className = "nx-cfg-thumb-label";
    name.textContent = labelFor(choice);
    el.appendChild(name);

    if (choice.price > 0) {
      const price = document.createElement("span");
      price.className = "nx-cfg-thumb-price";
      price.textContent = `+$${choice.price}`;
      el.appendChild(price);
    }
    wrap.appendChild(el);
  }
  return wrap;
}

function renderDropdown(group, state) {
  const wrap = document.createElement("div");
  wrap.className = "nx-cfg-dropdown-wrap";

  const select = document.createElement("select");
  select.className = "nx-cfg-dropdown";
  select.name = group.id;

  for (const choice of group.choices) {
    const opt = document.createElement("option");
    opt.value = choice.id;
    const label = labelFor(choice);
    opt.textContent = choice.price > 0 ? `${label}  (+$${choice.price})` : label;
    if (state[group.id] === choice.id) opt.selected = true;
    select.appendChild(opt);
  }

  wrap.appendChild(select);
  return wrap;
}

function isGroupDisabled(group, state) {
  if (!group.disabledWhen) return false;
  for (const key in group.disabledWhen) {
    if (state[key] === group.disabledWhen[key]) return true;
  }
  return false;
}

function renderBoolean(group, state) {
  const el = document.createElement("label");
  el.className = "nx-cfg-checkbox";
  const input = document.createElement("input");
  input.type = "checkbox";
  input.name = group.id;
  if (state[group.id]) input.checked = true;
  if (isGroupDisabled(group, state)) {
    input.disabled = true;
    el.classList.add("is-disabled");
  }
  const text = document.createElement("span");
  text.className = "nx-cfg-choice-label";
  text.textContent = group.label;
  el.appendChild(input);
  el.appendChild(text);
  if (group.price > 0) {
    const price = document.createElement("span");
    price.className = "nx-cfg-choice-price";
    price.textContent = `+$${group.price}`;
    el.appendChild(price);
  }
  return el;
}

// Keep boolean toggles in sync with their disabledWhen dependency after every
// refresh, so the user sees the disabled state immediately when they change
// the option that gates it.
function updateDependentControls(state, panelEl) {
  for (const group of CATALOG.groups) {
    if (group.type !== "boolean" || !group.disabledWhen) continue;
    const section = panelEl.querySelector(`[data-group-id="${group.id}"]`);
    if (!section) continue;
    const disabled = isGroupDisabled(group, state);
    const wrapper = section.querySelector(".nx-cfg-checkbox");
    const input = section.querySelector('input[type="checkbox"]');
    if (input) input.disabled = disabled;
    if (input && disabled) input.checked = false;
    if (wrapper) wrapper.classList.toggle("is-disabled", disabled);
  }
}

function renderMulti(group, state) {
  const wrap = document.createElement("div");
  wrap.className = "nx-cfg-checkboxes";
  const subState = state[group.id] || {};
  for (const choice of group.choices) {
    const el = document.createElement("label");
    el.className = "nx-cfg-checkbox";
    el.dataset.choiceId = choice.id;
    const input = document.createElement("input");
    input.type = "checkbox";
    input.name = `${group.id}.${choice.id}`;
    if (subState[choice.id]) input.checked = true;
    const text = document.createElement("span");
    text.className = "nx-cfg-choice-label";
    text.textContent = choice.label;
    const price = document.createElement("span");
    price.className = "nx-cfg-choice-price";
    price.dataset.priceLabel = choice.id;
    price.textContent = `+$${priceFor(choice, state)}`;
    el.appendChild(input);
    el.appendChild(text);
    el.appendChild(price);
    wrap.appendChild(el);
  }
  return wrap;
}

// Refresh price labels for multi-choice items whose price depends on other
// state (e.g. armrests scale with seatCapacity). Called from main.refresh().
function updateMultiPrices(state, panelEl) {
  for (const group of CATALOG.groups) {
    if (group.type !== "multi") continue;
    const section = panelEl.querySelector(`[data-group-id="${group.id}"]`);
    if (!section) continue;
    for (const choice of group.choices) {
      if (!choice.priceMap) continue;
      const priceEl = section.querySelector(`[data-price-label="${choice.id}"]`);
      if (priceEl) priceEl.textContent = `+$${priceFor(choice, state)}`;
    }
  }
}

function attachHandlers(state, panelEl, onChange) {
  panelEl.addEventListener("change", (e) => {
    const input = e.target;

    if (input instanceof HTMLSelectElement) {
      const section = input.closest(".nx-cfg-group");
      const groupId = section.dataset.groupId;
      state[groupId] = input.value;
      onChange();
      return;
    }

    if (!(input instanceof HTMLInputElement)) return;

    if (input.type === "radio") {
      // Find which group via the surrounding section's data attribute
      const section = input.closest(".nx-cfg-group");
      const groupId = section.dataset.groupId;
      state[groupId] = input.value;
      // Update selected styling
      section.querySelectorAll(".nx-cfg-swatch, .nx-cfg-radio, .nx-cfg-thumb").forEach(el => {
        el.classList.toggle("is-selected", el.querySelector("input").checked);
      });
    } else if (input.type === "checkbox") {
      const name = input.name;
      if (name.includes(".")) {
        const [groupId, choiceId] = name.split(".");
        state[groupId][choiceId] = input.checked;
      } else {
        state[name] = input.checked;
      }
    }

    onChange();
  });
}

function updatePriceDisplay(state) {
  const el = document.getElementById("nx-cfg-price");
  el.textContent = "$" + calculatePrice(state).toLocaleString();
}

function updateAddToCartGate(state) {
  const btn = document.getElementById("nx-cfg-add");
  btn.disabled = !isComplete(state);
}

function openCartModal(state) {
  const payload = buildPayload(state);
  const modal = document.getElementById("nx-cfg-modal");
  const spec = document.getElementById("nx-cfg-modal-spec");
  const total = document.getElementById("nx-cfg-modal-total");

  spec.innerHTML = "";
  for (const [k, v] of Object.entries(payload.properties)) {
    const dt = document.createElement("dt");
    dt.textContent = k;
    const dd = document.createElement("dd");
    dd.textContent = v;
    spec.appendChild(dt);
    spec.appendChild(dd);
  }
  total.textContent = "$" + payload.totalPrice.toLocaleString();

  modal.hidden = false;
  console.log("Add to Cart payload:", payload);
}

function closeCartModal() {
  document.getElementById("nx-cfg-modal").hidden = true;
}

function updateMandatoryWarnings(state, panelEl, modelKey) {
  for (const group of CATALOG.groups) {
    if (!group.mandatory) continue;
    if (group.models && modelKey && !group.models.includes(modelKey)) continue;
    const section = panelEl.querySelector(`[data-group-id="${group.id}"]`);
    if (!section) continue;
    let valid = false;
    if (group.type === "single") {
      valid = group.choices.some(c => c.id === state[group.id]);
    } else {
      valid = true;
    }
    section.classList.toggle("nx-cfg-group--missing", !valid);
  }
}

// Resolve which cart model this configurator is rendering. Priority order:
// 1. ?model= URL param (used in local dev)
// 2. data-product-handle attribute on .nx-cfg-app (set by the Liquid section)
// 3. data-model attribute on .nx-cfg-app (manual override)
// 4. fallback to "ge"
function resolveModel() {
  const params = new URLSearchParams(window.location.search);
  const fromParam = params.get("model");
  if (fromParam && MODELS[fromParam]) return fromParam;

  const appEl = document.querySelector(".nx-cfg-app");
  if (appEl) {
    const fromHandle = appEl.dataset.productHandle;
    if (fromHandle) {
      for (const [key, config] of Object.entries(MODELS)) {
        if (config.handle === fromHandle) return key;
      }
    }
    const fromModel = appEl.dataset.model;
    if (fromModel && MODELS[fromModel]) return fromModel;
  }

  return "ge";
}

const modelKey = resolveModel();
applyModel(modelKey);

const state = defaultState();

// Restore from a saved build if present. ?b=... is the current format (a
// short fixed-width code — see state.js for why). ?build=... and #... are the
// older base64-JSON payloads, still accepted so links already in circulation
// keep working.
const params = new URLSearchParams(window.location.search);
const shortCode = params.get("b");
const decodedShort = shortCode ? decodeBuildCode(shortCode) : null;
if (decodedShort) {
  Object.assign(state, decodedShort);
} else {
  const legacyHash = window.location.hash.length > 1 ? window.location.hash.slice(1) : null;
  const encodedBuild = params.get("build") || legacyHash;
  if (encodedBuild) {
    try {
      Object.assign(state, JSON.parse(decodeLegacyBuild(encodedBuild)));
    } catch (e) {
      // Invalid encoded build — ignore and use defaults.
    }
  }
}

// The page we're on decides the model, not the shared build: the link always
// lands on that model's product page, and modelKey drives the base price.
// Set it after the restore so a stale code can't disagree with what renders.
state.modelKey = modelKey;

// Legacy base64url decode. Accepts base64url, plain base64, and recovers from
// "+"->" " mangling (URLSearchParams turns "+" into a space, which corrupted
// the very first generation of shared builds).
function decodeLegacyBuild(str) {
  const std = str.replace(/-/g, "+").replace(/_/g, "/").replace(/ /g, "+");
  const pad = std.length % 4 === 0 ? std : std + "=".repeat(4 - (std.length % 4));
  return atob(pad);
}

const panelEl = document.getElementById("nx-cfg-options");

const shopifyForm = document.querySelector('form[action*="/cart/add"]');
const appEl = document.querySelector(".nx-cfg-app");
if (shopifyForm && appEl) {
  appEl.dataset.embed = "shopify";
  hideShopifyVariantPickers();
}
if (appEl) appEl.dataset.model = modelKey;

function refresh() {
  normalizeState(state);
  applyState(state, modelKey);
  updatePriceDisplay(state);
  updateAddToCartGate(state);
  updateMandatoryWarnings(state, panelEl, modelKey);
  updateMultiPrices(state, panelEl);
  updateDependentControls(state, panelEl);
  syncToShopifyForm();
  updateCartButtonLabel();
}

buildOptionPanel(state, panelEl, modelKey);
attachHandlers(state, panelEl, refresh);
refresh();

document.getElementById("nx-cfg-add").addEventListener("click", () => {
  if (shopifyForm) {
    syncToShopifyForm();
    shopifyForm.submit();
  } else {
    openCartModal(state);
  }
});
document.getElementById("nx-cfg-modal-close").addEventListener("click", closeCartModal);
document.getElementById("nx-cfg-modal-confirm").addEventListener("click", closeCartModal);

document.getElementById("nx-cfg-share").addEventListener("click", async () => {
  const encoded = encodeBuildCode(state);
  const url = `${window.location.origin}${window.location.pathname}?b=${encoded}`;
  window.history.replaceState(null, "", `?b=${encoded}`);

  const modelTitle = (MODELS[modelKey] && MODELS[modelKey].title) || "Custom Build";

  // On mobile, open the native share sheet so the user can send via Messages,
  // Mail, WhatsApp, etc. Desktop browsers don't support navigator.share, so
  // fall back to copying the URL.
  if (navigator.share) {
    try {
      await navigator.share({
        url: url,
        title: `My Custom ${modelTitle}`,
        text: `My custom ${modelTitle} build`
      });
      return;
    } catch (e) {
      if (e && e.name === "AbortError") return; // user dismissed share sheet
      // Fall through to clipboard fallback if share fails for any other reason.
    }
  }

  try {
    await navigator.clipboard.writeText(url);
    showToast("Build link copied");
  } catch (e) {
    showToast("Build saved to URL");
  }
});

function showToast(message) {
  const toast = document.getElementById("nx-cfg-toast");
  if (!toast) return;
  toast.textContent = message;
  toast.classList.add("is-show");
  clearTimeout(showToast._t);
  showToast._t = setTimeout(() => toast.classList.remove("is-show"), 2400);
}

function updateCartButtonLabel() {
  if (!shopifyForm) return;
  const label = shopifyForm.querySelector(".nx-cfg-cart-label");
  if (!label) return;
  if (label.textContent.toLowerCase().includes("sold out")) return;
  label.textContent = "Add to Cart — $" + calculatePrice(state).toLocaleString();
}

function syncToShopifyForm() {
  if (!shopifyForm) return;
  const payload = buildPayload(state);
  shopifyForm.querySelectorAll('input[data-nx-prop]').forEach(el => el.remove());
  for (const [k, v] of Object.entries(payload.properties)) {
    const input = document.createElement("input");
    input.type = "hidden";
    input.name = `properties[${k}]`;
    input.value = v;
    input.dataset.nxProp = "";
    shopifyForm.appendChild(input);
  }
}

function hideShopifyVariantPickers() {
  const selectors = [
    'fieldset.product-form__option',
    '.product-form__variants',
    '.product-options',
    '.product__variants',
    'fieldset[data-product-options]'
  ];
  for (const sel of selectors) {
    document.querySelectorAll(sel).forEach(el => {
      if (el.closest(".nx-cfg-app")) return;
      el.style.display = "none";
    });
  }
}

window.__nx = { state, refresh, modelKey };
})();
